import { createAction } from "@reduxjs/toolkit";
import { ProcessActionPayload } from "modules/common/actionPayload";

interface UpdateMemberPayload extends ProcessActionPayload {
  params: any;
}

const updateMemberInfo = createAction<UpdateMemberPayload>("member/updateMemberInfo");

export { updateMemberInfo };
